import { Rocket, Users, TrendingUp, Building2, Heart, Trophy } from "lucide-react";

const benefits = [
  { title: "Wzmocnienie zespołu", description: "Wspólne przeżycia budują silniejsze relacje i poprawiają komunikację wewnętrzną", icon: Users },
  { title: "Odprężenie i regeneracja", description: "Rozrywka na najwyższym poziomie pozwala odciąć się od codziennych wyzwań zawodowych", icon: Heart },
  { title: "Budowanie marki pracodawcy", description: "Wyjątkowe eventy wzmacniają employer branding i przyciągają najlepsze talenty", icon: Building2 },
  { title: "Wyższa efektywność zespołu", description: "Zadowoleni i zintegrowani pracownicy osiągają lepsze wyniki biznesowe", icon: TrendingUp },
  { title: "Innowacyjny wizerunek", description: "Nowoczesne atrakcje pokazują firmę jako organizację otwartą na nowe doświadczenia", icon: Rocket },
  { title: "Momenty, które zostają", description: "Tworzymy chwile, o których Twój zespół będzie opowiadać miesiącami", icon: Trophy },
];

export const Benefits = () => {
  return (
    <section id="benefits" className="py-24 section-white relative overflow-hidden">
      <div className="absolute inset-0 dot-pattern opacity-20" />
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-outfit font-bold text-center mb-4 text-foreground">
          Jakie korzyści <span className="text-gradient">zyskujesz?</span>
        </h2>
        <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
          Dlaczego firmy inwestują w atrakcje eventowe?
        </p>
        <div className="grid md:grid-cols-3 gap-5">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div 
                key={benefit.title} 
                className="card-elevated p-6 hover:border-primary/20 hover:-translate-y-1 group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/15 transition-colors">
                  <Icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-lg font-outfit font-bold mb-2 text-foreground">{benefit.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
